// extracted by mini-css-extract-plugin
module.exports = {"carouselLeft":"tr","carouselRight":"ur","disabled":"vr","sliderChevron":"wr","mobileSlider":"xr","desktopSlider":"yr"};